package com.example.mystybag.common.model

data class CountryVisualModel(
    val isoAlpha3 : String,
    val name      : String,
    val imageLink : String? = null,
    val isChecked : Boolean = false
): ListVisualModel(name, imageLink)
